<!-- && ctrl.invalid && (ctrl.dirty || ctrl.touched) -->
<div *ngIf="showError">
  <p class="text-sm text-danger" *ngIf="ctrl && ctrl.errors && ctrl.errors.required">
    <small>{{ fieldName || 'field' }} {{'userManagement.is required' | translate}}.</small>
  </p>
  <p class="text-sm text-danger" *ngIf="ctrl && ctrl.errors && ctrl.errors.minlength">
    <small>{{ fieldName || 'field' }} {{'userManagement.must be at least 4 characters long' | translate}}.</small>
  </p>
  <p class="text-sm text-danger" *ngIf="ctrl && ctrl.errors && ctrl.errors.maxlength">
    <small>{{ fieldName || 'field' }} {{'userManagement.must be at most 4 characters long' | translate}}.</small>
  </p>
  <p class="text-sm text-danger" *ngIf="ctrl && ctrl.errors && ctrl.errors.pattern">
    <small>{{ fieldName || 'field' }} {{ patternErrMsg || 'Pattern Error' }}</small>
  </p>
  <p class="text-sm text-danger" *ngIf="ctrl && ctrl.errors && ctrl.errors.email">
    <small>{{ fieldName || 'field' }} {{ patternErrMsg || 'Pattern Error' }}</small>
  </p>
</div>